export default __webpack_public_path__ + "static/media/whitelogo.a4e8f222.png";